import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import api from "../services/api";
import { getSession } from "../utils/session";

export default function HealthChildEntry() {
  const [rows, setRows] = useState([]);
  const [saved, setSaved] = useState([]);
  const [session, setSession] = useState(null);
  const [blocks, setBlocks] = useState([]);
    const months = [
      {label:"जनवरी", value:"January"},
      {label:"फरवरी", value:"February"},
      {label:"मार्च", value:"March"},
      {label:"अप्रैल", value:"April"},
      {label:"मई", value:"May"},
      {label:"जून", value:"June"},
      {label:"जुलाई", value:"July"},
      {label:"अगस्त", value:"August"},
      {label:"सितंबर", value:"September"},
      {label:"अक्टूबर", value:"October"},
      {label:"नवंबर", value:"November"},
      {label:"दिसंबर", value:"December"}
      ];
  useEffect(() => {
    const s = getSession();

    if (!s) {
      console.log("No session found");
      return;
    }

    setSession(s);
    setRows([emptyRow()]);
    loadChildren(s);
    loadBlocks();  
  }, []);

  const emptyRow = () => ({
    dob: "",
    father_name: "",
    mother_name: "",
    mobile: "",
    aadhaar: "",
    family_details: "",
    anganwadi_center: "",
    village: "",
    panchayat: "",
    block: "",
    district: "Bhojpur",
    health_center: "",
    month: "",
  });

  const loadChildren = async (s) => {
    try {
      const res = await api.get(`/children/block/${s.block_id}`);
      setSaved(res.data);
    } catch (err) {
      console.log(err);
    }
  };
  const loadBlocks = async () => {
    try {
      const res = await api.get("/admin/blocks");
  
      setBlocks(res.data);
  
    } catch (err) {
      console.log(err);
    }
  };
  const addRow = () => {
    setRows([...rows, emptyRow()]);
  };

  const removeRow = (index) => {
    const temp = [...rows];
    temp.splice(index, 1);
    setRows(temp);
  };

  const handleChange = (index, field, value) => {
    const temp = [...rows];
    temp[index][field] = value;
    setRows(temp);
  };

  const saveRow = async (row, index) => {
    if (!session) {
      alert("Session not loaded");
      return;
    }
  
    const selectedBlock = blocks.find(
      (b) => b.name === row.block
    );
  
    if (!selectedBlock) {
      alert("प्रखंड चुनें");
      return;
    }
  
    try {
      await api.post("/children", {
        ...row,
        block_id: selectedBlock.id,
        created_by: session.user_id,
      });
  
      removeRow(index);
      loadChildren(session);
  
    } catch (err) {
      console.log(err);
      alert("Save failed");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <div className="max-w-6xl mx-auto p-6">
        <h2 className="text-2xl font-bold mb-4 text-center">
          संस्थागत प्रसव से जन्म लेने वाली कन्या शिशुओं की विवरण
        </h2>

        {rows.map((row, i) => (
  <div
    key={i}
    className="bg-white shadow-md rounded-lg p-5 mb-6 border"
  >
    <h3 className="font-semibold text-gray-700 mb-2">
      मूल जानकारी
    </h3>

    <div className="grid grid-cols-4 gap-4 mb-4">

      <div>
        <label className="text-sm text-gray-600">जन्म तिथि *</label>
        <input
          type="date"
          required
          className="border p-2 rounded w-full"
          value={row.dob}
          onChange={(e)=>handleChange(i,"dob",e.target.value)}
        />
      </div>

      <div>
        <label className="text-sm text-gray-600">पिता का नाम *</label>
        <input
          required
          className="border p-2 rounded w-full"
          value={row.father_name}
          onChange={(e)=>handleChange(i,"father_name",e.target.value)}
        />
      </div>

      <div>
        <label className="text-sm text-gray-600">माता का नाम *</label>
        <input
          required
          className="border p-2 rounded w-full"
          value={row.mother_name}
          onChange={(e)=>handleChange(i,"mother_name",e.target.value)}
        />
      </div>

      <div>
        <label className="text-sm text-gray-600">मोबाइल संख्या *</label>
        <input
          required
          className="border p-2 rounded w-full"
          value={row.mobile}
          onChange={(e)=>handleChange(i,"mobile",e.target.value)}
        />
      </div>

    </div>

    <h3 className="font-semibold text-gray-700 mb-2">
      अतिरिक्त विवरण
    </h3>

    <div className="grid grid-cols-3 gap-4 mb-4">

      <div>
        <label className="text-sm text-gray-600">आधार संख्या *</label>
        <input
          required
          className="border p-2 rounded w-full"
          value={row.aadhaar}
          onChange={(e)=>handleChange(i,"aadhaar",e.target.value)}
        />
      </div>

      <div>
        <label className="text-sm text-gray-600">परिवार के सदस्य *</label>
        <input
          required
          className="border p-2 rounded w-full"
          value={row.family_details}
          onChange={(e)=>handleChange(i,"family_details",e.target.value)}
        />
      </div>

      <div>
        <label className="text-sm text-gray-600">आंगनवाड़ी केंद्र *</label>
        <input
          required
          className="border p-2 rounded w-full"
          value={row.anganwadi_center}
          onChange={(e)=>handleChange(i,"anganwadi_center",e.target.value)}
        />
      </div>

    </div>

    <h3 className="font-semibold text-gray-700 mb-2">
  पता विवरण
</h3>

<div className="grid grid-cols-4 gap-4 mb-4">

  {/* VILLAGE */}
  <div>
    <label className="text-sm text-gray-600">ग्राम *</label>
    <input
      required
      className="border p-2 rounded w-full"
      value={row.village}
      onChange={(e)=>handleChange(i,"village",e.target.value)}
    />
  </div>

  {/* PANCHAYAT */}
  <div>
    <label className="text-sm text-gray-600">पंचायत *</label>
    <input
      required
      className="border p-2 rounded w-full"
      value={row.panchayat}
      onChange={(e)=>handleChange(i,"panchayat",e.target.value)}
    />
  </div>

  {/* BLOCK DROPDOWN */}
  <div>
    <label className="text-sm text-gray-600">प्रखंड *</label>

    <select
  required
  className="border p-2 rounded w-full"
  value={row.block}
  onChange={(e)=>{
    handleChange(i,"block",e.target.value);
    handleChange(i,"district","Bhojpur");
  }}
>
  <option value="">प्रखंड चुनें</option>

  {blocks.map((b) => (
    <option key={b.id} value={b.name}>
      {b.name}
    </option>
  ))}

</select>

  </div>

  {/* DISTRICT AUTO */}
  <div>
    <label className="text-sm text-gray-600">जिला *</label>

    <input
      className="border p-2 rounded w-full bg-gray-100"
      value={row.district || "Bhojpur"}
      readOnly
    />

  </div>

</div>

    <h3 className="font-semibold text-gray-700 mb-2">
      स्वास्थ्य विवरण
    </h3>

    <div className="grid grid-cols-3 gap-4">

      <div>
        <label className="text-sm text-gray-600">स्वास्थ्य केंद्र *</label>
        <input
          required
          className="border p-2 rounded w-full"
          value={row.health_center}
          onChange={(e)=>handleChange(i,"health_center",e.target.value)}
        />
      </div>

      <div>
  <label className="text-sm text-gray-600">माह *</label>

  <select
    required
    className="border p-2 rounded w-full"
    value={row.month}
    onChange={(e)=>handleChange(i,"month",e.target.value)}
  >
    <option value="">माह चुनें</option>

    {months.map(m=>(
      <option key={m.value} value={m.value}>
        {m.label}
      </option>
    ))}

  </select>
</div>

      <div className="flex gap-2 items-end">
        <button
          disabled={!session}
          onClick={() => {

            if (!row.dob) {
              alert("जन्म तिथि भरें");
              return;
            }
          
            if (!row.father_name) {
              alert("पिता का नाम भरें");
              return;
            }
          
            if (!row.mother_name) {
              alert("माता का नाम भरें");
              return;
            }
          
            if (!row.mobile) {
              alert("मोबाइल संख्या भरें");
              return;
            }
          
            if (!row.aadhaar) {
              alert("आधार संख्या भरें");
              return;
            }
          
            if (!row.family_details) {
              alert("परिवार के सदस्य भरें");
              return;
            }
          
            if (!row.anganwadi_center) {
              alert("आंगनवाड़ी केंद्र भरें");
              return;
            }
          
            if (!row.village) {
              alert("ग्राम भरें");
              return;
            }
          
            if (!row.panchayat) {
              alert("पंचायत भरें");
              return;
            }
          
            if (!row.block) {
              alert("प्रखंड भरें");
              return;
            }
          
            if (!row.district) {
              alert("जिला भरें");
              return;
            }
          
            if (!row.health_center) {
              alert("स्वास्थ्य केंद्र भरें");
              return;
            }
          
            if (!row.month) {
              alert("माह भरें");
              return;
            }
          
            saveRow(row, i);
          }}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Save
        </button>

        <button
          onClick={()=>removeRow(i)}
          className="bg-red-500 text-white px-4 py-2 rounded"
        >
          Remove
        </button>
      </div>

    </div>

  </div>
))}

        <button
          onClick={addRow}
          className="bg-gray-700 text-white px-5 py-2 rounded"
        >
          + Add Row
        </button>

        <h3 className="text-xl font-semibold mt-8 mb-3">
          Saved Records
        </h3>

        <div className="bg-white shadow rounded p-4 overflow-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2">DOB</th>
                <th className="p-2">Father</th>
                <th className="p-2">Mother</th>
                <th className="p-2">Mobile</th>
                <th className="p-2">Aadhaar</th>
                <th className="p-2">Village</th>
                <th className="p-2">Month</th>
              </tr>
            </thead>

            <tbody>
              {saved.map((r) => (
                <tr key={r.id} className="border-t">
                  <td className="p-2">{r.dob}</td>
                  <td className="p-2">{r.father_name}</td>
                  <td className="p-2">{r.mother_name}</td>
                  <td className="p-2">{r.mobile}</td>
                  <td className="p-2">{r.aadhaar}</td>
                  <td className="p-2">{r.village}</td>
                  <td className="p-2">{r.month}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}